import { render, staticRenderFns } from "./Criar.vue?vue&type=template&id=2fa0bf8c&scoped=true&"
import script from "./Criar.vue?vue&type=script&lang=js&"
export * from "./Criar.vue?vue&type=script&lang=js&"
import style0 from "./Criar.vue?vue&type=style&index=0&id=2fa0bf8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0bf8c",
  null
  
)

export default component.exports